import {Component, Input, OnInit} from '@angular/core';
import {SharedStoreFacade} from 'app/main/shared/shared/store/shared-store.facade';
import {AuthenticationTypeEnum, SigningStatusEnum} from 'app/main/signing-pages/enums/enum';
import {RoleDetail} from 'app/main/signing-pages/signing-page/signing-page.dto';
import {UserSettings} from '../../../../../global/user-settings.dto';
import {ActivityLogs, ActivityLogStatusEnum, SignableType} from '../activity-logs-dto';

@Component({
  selector: 'app-activity-log-container',
  templateUrl: './activity-log-container.component.html',
  styleUrl: './activity-log-container.component.scss'
})
export class ActivityLogContainerComponent implements OnInit {
  @Input() activities: ActivityLogs = {} as ActivityLogs;
  @Input() roleId: number = 0;
  @Input() is_sender: number = 0;
  @Input() roleDetail: RoleDetail;
  @Input() loggedInUser: UserSettings = {} as UserSettings;

  public activities$ = this.sharedFacade.activities$;
  public signingStatusEnum = SigningStatusEnum;
  public authenticationTypeEnum = AuthenticationTypeEnum;
  public activityLogStatusEnum = ActivityLogStatusEnum;
  public signableType = SignableType;
  constructor (private sharedFacade: SharedStoreFacade) {}
  
  ngOnInit(): void {
    this.activities$.subscribe((response) => {
      const ids = response
        .filter((activity) => {
          const isSenderAndNotSignableUser = this.is_sender == 1 && this.loggedInUser?.id != activity.signable_id;
          const isNotSenderAndNotSignableRole = this.is_sender == 0 && this.roleId != activity.signable_id;
          return (isSenderAndNotSignableUser || isNotSenderAndNotSignableRole) && (activity?.activity_type === 'chat' && activity?.msg_status?.status !== 'seen');
        })
        .map((activity: ActivityLogs) => activity.id);
      if(ids.length){
        if(this.is_sender == 1){
          this.sharedFacade.updateDocumentActivityStatus(this.roleId, ids)
        } else {
          this.sharedFacade.updateRecipientActivityStatus(this.roleId, ids);
        }
      }
    });
  }
}
